export default __webpack_public_path__ + "static/media/4_soft_tissues.64f350b3.webp";